import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetRedirectGuard implements CanActivate {

  constructor(
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ): any {
    const queryParams = route.queryParams;
    this.router.navigate(['/reset-password'], { queryParams });
    return false;
  }

  
} 